import { call, put, takeLatest } from 'redux-saga/effects';
import { DISCONNECT_ASSET_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { actionTypes } from '../../../constants';
import { getAssetDisconnectAction } from './actions';
function* disconnectedAssetSaga(action) {
    yield put(getAssetDisconnectAction(apiCallStatus.LOADING));
    try {
        yield call(GatewayManagementApi.disconnectGatewayAsset, action.assetId, action.gatewayId);
        yield put(getAssetDisconnectAction(apiCallStatus.SUCCESS));
        notify(translate('ABB.Powertrain.Frontend.AssetDisconnectedSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        yield put({
            type: actionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: action.gatewayId }
        });
        if (typeof action.onResetAssetInfo === 'function') {
            yield call(action.onResetAssetInfo);
        }
    } catch (error) {
        yield put(getAssetDisconnectAction(apiCallStatus.ERROR, [], error));
    }
}
export function* DisconnectAssetWatchers() {
    yield takeLatest(DISCONNECT_ASSET_REQUEST, disconnectedAssetSaga);
}
